import { getFeatureAssetBaseUrl } from "./FeatureAssets";

export const getCustomFontUrl = (fontDataOrFile, campaignId) => {
    const fontFile_raw = typeof fontDataOrFile === 'string' ? fontDataOrFile : fontDataOrFile?.fontFilename;
    const fontFile = fontFile_raw?.split('/')?.pop() ?? fontFile_raw;
    const resolvedSourceCampaignId = typeof fontDataOrFile === 'object'
        ? fontDataOrFile?.assetSourceCampaignId
        : null;
    const isTemplateFont = Boolean(resolvedSourceCampaignId) && typeof fontDataOrFile === 'object'
        && (fontDataOrFile?.assetSourceType === 'template' || fontDataOrFile?.assetSourceTemplateId);
    const resolvedCampaignId = resolvedSourceCampaignId || campaignId;
    const fontBaseUrl = getFeatureAssetBaseUrl() + `campaigns/${resolvedCampaignId ?? 'no-campaign'}/fonts/`;
    const fontUrl = fontBaseUrl + fontFile;
    console.log('[FONT URL]', { fontFile, isTemplateFont, resolvedCampaignId, fontUrl, inputData: fontDataOrFile });
    return fontUrl;
}

// Iframe-based legacy features apply font families as unquoted inline CSS. A
// user-facing family such as "1KOMIKAX_TEST123" is valid when quoted, but is
// invalid in that legacy CSS path. Use a deterministic, CSS-safe alias only in
// runtime messages; the campaign continues to store and display the original
// font name.
export const getCustomFontRuntimeFamily = (fontFamily) => {
    const compactFamily = String(fontFamily ?? '').replace(/\s+/g, '');
    const safeFamily = compactFamily.replace(/[^a-zA-Z0-9_-]/g, (character) => (
        `_${character.codePointAt(0).toString(16)}_`
    ));

    return `KokoCustomFont_${safeFamily}`;
};

export const mapCustomFontFamiliesForRuntime = (data, customFonts = []) => {
    if (!Array.isArray(customFonts) || customFonts.length === 0) return data;

    const runtimeFamilyByStoredFamily = new Map();
    customFonts.forEach((font) => {
        if (typeof font?.fontFamily !== 'string' || !font.fontFamily) return;

        const runtimeFamily = getCustomFontRuntimeFamily(font.fontFamily);
        runtimeFamilyByStoredFamily.set(font.fontFamily, runtimeFamily);
        runtimeFamilyByStoredFamily.set(font.fontFamily.replace(/\s+/g, ''), runtimeFamily);
    });

    const mapValue = (value) => {
        if (typeof value === 'string') {
            const mappedValue = runtimeFamilyByStoredFamily.get(value);
            return {
                value: mappedValue ?? value,
                changed: Boolean(mappedValue),
            };
        }
        if (Array.isArray(value)) {
            const mappedValues = value.map(mapValue);
            const changed = mappedValues.some((mappedValue) => mappedValue.changed);
            return {
                value: changed ? mappedValues.map((mappedValue) => mappedValue.value) : value,
                changed,
            };
        }
        if (value && typeof value === 'object') {
            const mappedEntries = Object.entries(value).map(([key, nestedValue]) => [key, mapValue(nestedValue)]);
            const changed = mappedEntries.some(([, mappedValue]) => mappedValue.changed);
            return {
                value: changed
                    ? Object.fromEntries(mappedEntries.map(([key, mappedValue]) => [key, mappedValue.value]))
                    : value,
                changed,
            };
        }
        return { value, changed: false };
    };

    return mapValue(data).value;
};

export const applyCampaignCustomFontsCss = (campaignData) => {
    if (!campaignData || !campaignData.customFonts || campaignData.customFonts.length === 0) return;
    
    for (let i = 0; i < campaignData.customFonts.length; i++) {
        const fontUrl = getCustomFontUrl(campaignData.customFonts[i], campaignData._id);
        const fontFamily = campaignData.customFonts[i].fontFamily;
        applyFontPreview(fontFamily, fontUrl, '.apply-custom-font-' + fontFamily.replace(/ /g, ''));
    }
}

export const applyFontPreview = (fontFamily, fontUrl, elementClass = '.apply-custom-font') => {
    // Create a font face style in the header if it doesn't already exist
    fontFamily = fontFamily.replace(/ /g, ''); // Replace spaces with nothing

    const styleId = 'custom-font-' + fontFamily + '-style';
    const existingStyle = document.getElementById(styleId);
    if (!existingStyle) {
        const customFontStyle = document.createElement('style');
        customFontStyle.id = styleId;
        customFontStyle.innerHTML = `
            @font-face {
                font-family: '${fontFamily}';
                src: url('${fontUrl}');
            }
        `;
        document.head.appendChild(customFontStyle);
    } else {
        // Ensure the font url is correct as it could have changed
        existingStyle.innerHTML = `
            @font-face {
                font-family: '${fontFamily}';
                src: url('${fontUrl}');
            }
        `;
    }

    // Create a style in the header for the custom font preview element, if it exists apply the updated font family, otherwise create it
    const elementStyleId = 'custom-font-preview-' + elementClass.substring(1) + '-style';
    const existingElementStyle = document.getElementById(elementStyleId);
    if (!existingElementStyle) {
        const customFontPreviewElementStyle = document.createElement('style');
        customFontPreviewElementStyle.id = elementStyleId;
        customFontPreviewElementStyle.innerHTML = `
            ${elementClass} {
                font-family: '${fontFamily}';
            }
        `;
        document.head.appendChild(customFontPreviewElementStyle);
    } else {
        existingElementStyle.innerHTML = `
            ${elementClass} {
                font-family: '${fontFamily}';
            }
        `;
    }
}

export const FontPreviewBlock = (props) => {
    return (
        <div className={`fl-column ${props.className ?? 'apply-font'}`} style={{ maxHeight: (props.maxHeight ?? '20rem'), overflowY: 'auto' }}>
            <h3>The quick brown fox jumps over the lazy dog.</h3>
            <h4>The quick brown fox jumps over the lazy dog.</h4>
            <h5>The quick brown fox jumps over the lazy dog.</h5>
            <p>The quick brown fox jumps over the lazy dog.</p>
        </div>
    )
}
